import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from './context';




//contexts>
// GLOBALCONTEXT>
//    CAMERACONTEXT>
//        BOARDCONTEXT>
//            ENEMYCONTET/
//            PLAYERCONTEXT>


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);

